import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Table from '../table/Table';
import { getColumns } from '../../utils/users';
import AddEditUserModal from './AddEditUserModal';
import AccountDetailsModal from './AccountDetailsModal';

const UsersPageWrapper = ({
  users,
  modals,
  closeModal,
  onOpenEditModal,
  onOpenAccountDetailsModal,
  onSubmitAddEditUserModal,
  onResendEmail,
  isDisabled,
  setIsDisabled,
  setErrorMessage,
  errorMessage,
  organization,
  onDeactivate,
  currentUserId = null,
  currentUserEmail = '',
  isCurrentUserManager = false,
}) => {
  // Determine modal data
  const fieldToEdit = useMemo(() => {
    if (!modals.editUser?.isOpen) return null;
    return users.find(u => u.id === Number(modals.editUser.value)) || null;
  }, [modals.editUser?.isOpen, modals.editUser?.value, users]);

  const accountUser = useMemo(() => {
    if (!modals.accountDetails?.isOpen) return null;
    return users.find(u => u.id === Number(modals.accountDetails.value)) || null;
  }, [modals.accountDetails?.isOpen, modals.accountDetails?.value, users]);

  const columns = useMemo(() => getColumns(organization.id, onOpenAccountDetailsModal), [organization.id, onOpenAccountDetailsModal]);

  return (
    <>
      <Table
        typeOfData="users"
        columns={columns}
        dataSource={users}
        onClick={onOpenEditModal}
        isUsingLinkWrapper={false}
      />

      {(modals.inviteUser?.isOpen || (modals.editUser?.isOpen && fieldToEdit)) && (
        <AddEditUserModal
          onCloseModal={() => { closeModal('inviteUser'); closeModal('editUser'); }}
          userData={modals.editUser?.isOpen ? fieldToEdit : {}}
          onSubmit={onSubmitAddEditUserModal}
          errorMessage={errorMessage}
          isDisabled={isDisabled}
          setIsDisabled={setIsDisabled}
          setErrorMessage={setErrorMessage}
          organization={organization}
          onDeactivate={onDeactivate}
          currentUserId={currentUserId}
          currentUserEmail={currentUserEmail}
          isCurrentUserManager={isCurrentUserManager}
        />
      )}

      {modals.accountDetails?.isOpen && (
        <AccountDetailsModal
          user={accountUser}
          onClose={() => closeModal('accountDetails')}
          onResendEmail={onResendEmail}
          organization={organization}
        />
      )}
    </>
  );
};

UsersPageWrapper.propTypes = {
  users: PropTypes.array.isRequired,
  modals: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  errorMessage: PropTypes.object.isRequired,
  onOpenEditModal: PropTypes.func.isRequired,
  onOpenAccountDetailsModal: PropTypes.func.isRequired,
  onSubmitAddEditUserModal: PropTypes.func.isRequired,
  onResendEmail: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  setIsDisabled: PropTypes.func.isRequired,
  setErrorMessage: PropTypes.func.isRequired,
  organization: PropTypes.object.isRequired,
  onDeactivate: PropTypes.func.isRequired,
  currentUserId: PropTypes.number,
  currentUserEmail: PropTypes.string,
  isCurrentUserManager: PropTypes.bool,
};

export default UsersPageWrapper;
